export default __webpack_public_path__ + "static/media/Nitroxgallery_9.7fbdf79e.JPG";